import { ReactNode } from 'react';
import styles from './FilterButton.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

interface FilterButtonProps {
  children: ReactNode;
  Icon?: React.FC<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >;
  iconFill?: string;
  iconStroke?: string;
  theme?: 'orange';
  active?: boolean;
  disabled?: boolean;
  className?: string;
  onClick: (e: React.MouseEvent) => void;
}

export default function FilterButton({
  children,
  Icon,
  iconFill = 'none',
  iconStroke,
  theme,
  active,
  disabled,
  className,
  onClick,
}: FilterButtonProps): JSX.Element {
  return (
    <button
      className={cx(
        'root',
        theme && theme,
        active && 'active',
        className && className
      )}
      disabled={disabled}
      onClick={onClick}
    >
      {Icon && (
        <Icon
          className={styles.icon}
          fill={iconFill}
          stroke={iconStroke}
        />
      )}
      {children}
    </button>
  );
}
